export default __webpack_public_path__ + "static/gato-estudio-balthazaurus-scroll-7c9ca9b8fe2d75986cf33db21ec14ba5.mp4";